module.exports = __webpack_public_path__ + "img/42bf08a1810ac93ae76cd5b3c4cf4492.png";